import Button from 'antd/es/button';
import Form from 'antd/es/form';
import Input from 'antd/es/input';
import Radio from 'antd/es/radio';
import Select from 'antd/es/select';
import Space from 'antd/es/space';
import { useTranslation } from 'react-i18next';
import { useUnit } from 'effector-react';
import { useMemo, useState } from 'react';
import { $pollOptions } from '../../models/bizPollsModel/index.js';
import style from './BizPolls.module.css';

const limits = {
  6: 2,
  7: 3,
  8: 2,
  9: 2,
  10: 3,
};

function TableQuestion({
  q,
  question,
  type,
  blocked,
  blockedOptions,
  first,
  last,
}) {
  const { t } = useTranslation();

  return (
    <div
      className={
        first
          ? style.range_subquestion_wrapper_first
          : last
          ? style.range_subquestion_wrapper_last
          : style.range_subquestion_wrapper
      }
    >
      <div
        className={[
          question.is_required
            ? style.range_subquestion
            : style.range_subquestion_noreq,
          blocked.includes(question?.id) ? style.blocked : '',
        ].join(' ')}
      >
        {t(`biz-polls-year.subquestions.${type}.${q?.id}.${question?.id}`)}
      </div>
      <Form.Item
        rules={
          blocked.includes(question?.id) || !question.is_required
            ? null
            : [{ required: true, message: t('Обязательное поле') }]
        }
        layout="horizontal"
        name={[question?.id, 'value']}
        style={{
          width: 'calc(100% - 320px)',
          textAlign: 'center',
        }}
        className={style.test}
      >
        <Radio.Group
          className={style.range_radiobuttons}
          disabled={blocked.includes(question?.id)}
        >
          {q.options.map((option) => {
            return (
              <Radio
                key={`question-${question?.id}-${option?.id}`}
                value={option.value}
                disabled={
                  blockedOptions[question?.id] &&
                  +option.value === blockedOptions[question?.id]
                }
              />
            );
          })}
        </Radio.Group>
      </Form.Item>
    </div>
  );
}

function YearQuestion({ q, type, blocked, year, blockedOptions, num }) {
  const { t } = useTranslation();
  const [value, setValue] = useState(null);

  const agencies = useMemo(() => {
    return Array.from(
      new Set(q.group_questions.map((item) => item.agency))
    ).filter((item) => item !== null);
  }, [q]);

  if (q.is_table) {
    return (
      <div className={style.range_question}>
        {agencies.length > 0 ? (
          agencies.map((agency, index) => {
            return (
              <>
                <div className={style.table_question_agency_title}>
                  {t(
                    `biz-polls-year.subquestions_title.${type}.${q?.id}.${
                      index + 1
                    }`
                  )}
                </div>
                <div className={style.table_question_cnt}>
                  <div className={style.range_variants_top}>
                    <div className={style.range_variants_wrapper}>
                      {q.options.map((option) => {
                        return (
                          <div
                            key={`option-${q?.id}-${option?.id}`}
                            className={style.range_variant}
                          >
                            {t(
                              `biz-polls-year.answers.${type}.q${q?.id}.${option?.id}`
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  {q.group_questions
                    .filter((question) => question.agency === agency)
                    .map((question, idx, arr) => {
                      return (
                        <TableQuestion
                          q={q}
                          question={question}
                          first={idx === 0}
                          last={idx === arr.length - 1}
                          type={type}
                          blocked={blocked}
                          blockedOptions={blockedOptions}
                          key={`question-${q?.id}-subquestion-${question?.id}`}
                        />
                      );
                    })}
                </div>
              </>
            );
          })
        ) : (
          <div className={style.table_question_cnt}>
            <div className={style.range_variants_top}>
              <div className={style.range_variants_wrapper}>
                {q.options.map((option) => {
                  return (
                    <div
                      key={`option-${q?.id}-${option?.id}`}
                      className={style.range_variant}
                    >
                      {t(
                        `biz-polls-year.answers.${type}.q${q?.id}.${option?.id}`
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
            {q.group_questions.map((question, idx) => {
              return (
                <TableQuestion
                  q={q}
                  question={question}
                  first={idx === 0}
                  last={idx === q.group_questions.length - 1}
                  type={type}
                  blocked={blocked}
                  blockedOptions={blockedOptions}
                  key={`question-${q?.id}-subquestion-${question?.id}`}
                />
              );
            })}
          </div>
        )}
      </div>
    );
  }
  return (
    <div className={style.table_question_cnt}>
      <Form.Item
        // label={
        //   <label style={{ fontWeight: 600 }}>
        //     {`${num + 1}.${t(`biz-polls-year.questions.${type}.${q?.id}`)}`}
        //   </label>
        // }
        label={null}
        rules={
          blocked.includes(q.group_questions[0]?.id) ||
          !q.group_questions?.[0]?.is_required
            ? null
            : [{ required: true, message: t('Обязательное поле') }]
        }
        name={[q.group_questions[0] ? q.group_questions[0]?.id : q.id, 'value']}
      >
        <Radio.Group
          onChange={({ target: { value } }) => setValue(value.toString())}
          disabled={blocked.includes(q.group_questions[0]?.id)}
        >
          <Space direction="vertical">
            {q.options.map((opt) => (
              <Radio
                value={opt.is_custom ? 'custom' : opt.value}
                key={opt.value}
              >
                {t(`biz-polls-year.answers.${type}.q${q?.id}.${opt?.id}`)}
              </Radio>
            ))}
          </Space>
        </Radio.Group>
      </Form.Item>
      {(value === 'custom' || value?.includes('custom')) && (
        <Form.Item
          name={[
            q.group_questions[0] ? q.group_questions[0]?.id : q?.id,
            'custom',
          ]}
          label={t(`biz-polls.custom`)}
          rules={[{ required: true, message: t('Обязательное поле') }]}
        >
          <Input.TextArea />
        </Form.Item>
      )}
    </div>
  );
}

function Question({ q, type, blocked, year, blockedOptions, num, form }) {
  const { t } = useTranslation();
  const [value, setValue] = useState(null);

  if (year) {
    return (
      <YearQuestion
        q={q}
        type={type}
        blocked={blocked}
        blockedOptions={blockedOptions}
        num={num}
      />
    );
  }

  return (
    <>
      <Form.Item
        name={[q?.id, 'value']}
        // label={
        //   <label style={{ fontWeight: 600 }}>{`${num + 1}.${t(
        //     `biz-polls.questions.${type}.${q?.id}`
        //   )}`}</label>
        // }
        label={null}
        rules={
          blocked.includes(q?.id)
            ? null
            : [{ required: true, message: t('Обязательное поле') }]
        }
      >
        {q.is_multiselect ? (
          <Select
            onChange={(val) => setValue(val)}
            options={q.options.map((opt) => ({
              value: opt.is_custom ? 'custom' : opt.value,
              label: t(
                `biz-polls.answers.${type}.q${opt.question_id}.${opt?.id}`
              ),
            }))}
            mode="multiple"
            maxCount={limits[q?.id]}
            disabled={blocked.includes(q?.id)}
          />
        ) : (
          <Radio.Group
            onChange={({ target: { value } }) => setValue(value)}
            disabled={blocked.includes(q?.id)}
          >
            <Space direction="vertical">
              {q.options.map((opt) => (
                <Radio
                  value={opt.is_custom ? 'custom' : opt.value}
                  key={opt.value}
                >
                  {t(
                    `biz-polls.answers.${type}.q${opt.question_id}.${opt?.id}`,
                    { defaultValue: opt.name }
                  )}
                </Radio>
              ))}
            </Space>
          </Radio.Group>
        )}
      </Form.Item>
      {(value === 'custom' || value?.includes('custom')) && (
        <Form.Item
          name={[q?.id, 'custom']}
          label={t(`biz-polls.custom`)}
          rules={[{ required: true, message: t('Обязательное поле') }]}
        >
          <Input.TextArea />
        </Form.Item>
      )}
    </>
  );
}

export default function BizPollQuestions({
  type,
  blocked,
  year,
  blockedOptions,
  pollForm,
}) {
  const { t } = useTranslation();
  const questions = useUnit($pollOptions);

  const [current, setCurrent] = useState(0);

  const formItems = useMemo(() => {
    if (questions && questions.length > 0) {
      return questions.map((q, index) => ({
        key: index,
        label: t(`biz-polls.questions.${type}.${q?.id}`, {
          defaultValue: q.question,
        }),
        renderedItem: (
          <Question
            form={pollForm}
            key={q?.id}
            q={q}
            type={type}
            blocked={blocked}
            year={year}
            blockedOptions={blockedOptions}
            num={index}
          />
        ),
      }));
    }
  }, [type, questions, blocked, blockedOptions]);

  const next = () => {
    // Validate current step before moving forward
    const currentFields = getCurrentStepFields();
    pollForm
      .validateFields(currentFields)
      .then(() => {
        setCurrent((prev) => prev + 1);
      })
      .catch((errorInfo) => {
        console.log('Validation failed:', errorInfo);
      });
  };

  const getCurrentStepFields = () => {
    const currentQuestion = questions[current];
    if (!currentQuestion) return [];

    if (year && currentQuestion.is_table) {
      return currentQuestion.group_questions.map((q) => [q.id, 'value']);
    }

    const fields = [
      [currentQuestion.group_questions?.[0]?.id ?? currentQuestion.id, 'value'],
    ];
    // Check if custom field is needed
    const formValue = pollForm.getFieldValue([
      currentQuestion.group_questions?.[0]?.id ?? currentQuestion.id,
      'value',
    ]);
    if (formValue === 'custom' ?? formValue?.includes?.('custom')) {
      fields.push([
        currentQuestion.group_questions?.[0]?.id ?? currentQuestion.id,
        'custom',
      ]);
    }
    return fields;
  };

  return (
    <div className={style.content_card}>
      {formItems.map((item, index) => (
        <div
          key={item.key}
          style={{ display: index === current ? 'block' : 'none' }}
        >
          <div className={'flex-16'} style={{ marginBottom: 24 }}>
            <div className={style.question_counter}>
              {current + 1}/{formItems.length}
            </div>
            <span className={style.question_title}>{item.label}</span>
          </div>
          {item.renderedItem}
        </div>
      ))}
      <div style={{ display: 'flex', gap: '8px' }}>
        {current > 0 && (
          <Button onClick={() => setCurrent((prev) => prev - 1)}>Назад</Button>
        )}
        {current + 1 < formItems.length && (
          <Button type="primary" onClick={next}>
            Далее
          </Button>
        )}
        {current + 1 === formItems.length && (
          <Button type="primary" onClick={() => pollForm.submit()}>
            {t('biz-polls.submit')}
          </Button>
        )}
      </div>
    </div>
  );
}
